import React from 'react'
import  sAction  from "sAction";
import PureComponent from '../../pure'
class quickCreateActMenu extends PureComponent{

    constructor(props){
        super(props);

        this.state = {
            activeTab : props.activeTab,
        };

    }

    clickHandle(target){
        this.props.clickFnc(target);
        this.setState({activeTab: target});

        let header = "";
        let color = "";
        let icon = "";

        switch(target){
            case "detailMeeting":
                header = sAction.translate("LBL_TITLE_CREATE_NEW_MEETING", "Calendar");
                color = "MeetingsCalTitle";
                icon = "icon-Meetings";
                break;
            case "detailCall":
                header = sAction.translate("LBL_TITLE_CREATE_NEW_CALL", "Calendar");
                color = "CallsCalTitle";
                icon = "icon-Calls";
                break;
            case "detailTask":
                header = sAction.translate("LBL_TITLE_CREATE_NEW_TASK", "Calendar");
                color = "TasksCalTitle";
                icon = "icon-Tasks";
                break;
        }

        sAction.dataSet(this.props.way+"/data/header", header);
        sAction.dataSet(this.props.way+"/data/color", color);
        sAction.dataSet(this.props.way+"/data/icon", icon);
    }

    render(){
        let meetClass = "";
        let callClass = "";
        let taskClass = "";

        switch(this.state.activeTab){
            case "detailMeeting":
                meetClass = " activeTab";
                break;
            case "detailCall":
                callClass = " activeTab";
                break;
            case "detailTask":
                taskClass = " activeTab";
                break;
        }

        let navClass = "quickCreateNav";

        if(this.props.menuOpen === false){
            navClass += " min";
        }

        return(
            <nav className={navClass}>
                <a className={"calQuicCreateTabMenuButton"+meetClass} onClick={() => {this.clickHandle("detailMeeting")}}><div className="calActMenuIcon icon-meetings"></div></a>
                <a className={"calQuicCreateTabMenuButton"+callClass} onClick={() => {this.clickHandle("detailCall")}}><div className="calActMenuIcon icon-calls"></div></a>
                <a className={"calQuicCreateTabMenuButton"+taskClass} onClick={() => {this.clickHandle("detailTask")}}><div className="calActMenuIcon icon-tasks"></div></a>
            </nav>
        );

    }

}export default quickCreateActMenu